import { ServiceProvider } from "@sa/rep-services-provider";
import {DictionariesService} from '@sa/rep-mdm';
import { DataService, DictionariesAPIService, ReportService, ReportExportService, DictionariesCacheService, HistoryReportsService, DataSourcesService, ServicesRegister } from "./shared";
import { OLAPService } from "@sa/rep-olap";

const apiUrl = process.env.REACT_APP_API_URL || '/api';
const apiReportingUrl = process.env.REACT_APP_REPORTING_V2_API_URL || '/api-reportng-v2';

// Создаём контейнер сервисов, регистрируем сервисы
export const serviceProvider = new ServiceProvider();

const dictionariesAPIService = new DictionariesAPIService({
  baseUrl: apiReportingUrl
})
export const dictionaryService = new DictionariesService(dictionariesAPIService, dictionariesAPIService, new DictionariesCacheService());

const dataAPIService = new DataService({
  baseUrl: apiReportingUrl,
});

export const dataService = new OLAPService(dataAPIService, dataAPIService, dictionaryService);

export const reportService = new ReportService({
  baseUrl: apiUrl,
});

export const reportExportService = new ReportExportService({
  baseUrl: apiUrl,
  baseReportingUrl: apiReportingUrl,
});

export const historyReportsService = new HistoryReportsService({
  baseUrl: apiUrl,
});

export const dataSourcesService = new DataSourcesService(dictionaryService);

serviceProvider.singleton("DataSourcesService", dataSourcesService);
serviceProvider.singleton("DataService", dataService);
serviceProvider.singleton(ServicesRegister.Dictionary, dictionaryService);